export default __webpack_public_path__ + "static/media/deadbush.b1d2dba1.png";